import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

//Staging
const firebaseConfig = {
    apiKey: "AIzaSyBvnY7GLuI8wzne0fkVyYVA7RApMgBRNM0",
    authDomain: "tt-be-582b2.firebaseapp.com",
    projectId: "tt-be-582b2",
    storageBucket: "tt-be-582b2.firebasestorage.app",
    messagingSenderId: "529457573756",
    appId: "1:529457573756:web:1412dc092d606b4b73fef9"
};

//Production
// const firebaseConfig = {
//     apiKey: "AIzaSyDvyMcru8GNjv-aNcm_7L0VyCo5wYMhlmI",
//     authDomain: "tt-be-production.firebaseapp.com",
//     projectId: "tt-be-production",
//     storageBucket: "tt-be-production.firebasestorage.app",
//     messagingSenderId: "762773504333",
//     appId: "1:762773504333:web:3798f436c54a48fe70b704"
// };

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Cloud Messaging
const messaging = getMessaging(app);

let isListenerAttached = false;
console.log("isListenerAttached ",isListenerAttached)
const subscribeToMessages = () => {
    if (!isListenerAttached) {
      isListenerAttached = true;
      onMessage(messaging, (payload) => {
        console.log("Foreground Push Notification:", payload);
        // displayNotification(payload);
      });
    }
  };

// Function to display push notification
const displayNotification = (payload) => {
  console.log("above ",payload,  Notification.permission, "Notification" in window)
  // Ensure the browser supports notifications
  if ("Notification" in window && Notification.permission === "granted") {
    const { title, body } = payload.notification; // Assuming payload contains notification.title and notification.body
    console.log("first within ",title,body)
    const notificationOptions = {
      body: body,
      icon: payload.notification.icon || '/default-icon.png', // You can use a custom icon here
      badge: payload.notification.badge || '/default-badge.png',
    };

    // Show the notification
    new Notification(title, notificationOptions);
  } else {
    // If notification permissions aren't granted, request permission
    Notification.requestPermission().then((permission) => {
      if (permission === "granted") {
        const { title, body } = payload.notification;
        console.log("second within ",title,body)
        const notificationOptions = {
          body: body,
          icon: payload.notification.icon || '/default-icon.png',
          badge: payload.notification.badge || '/default-badge.png',
        };
        new Notification(title, notificationOptions);
      }
    });
  }
};

export { messaging, getToken, onMessage, subscribeToMessages };
